import { scrypt } from "scrypt-js";

import CryptoJS from "crypto-js";
 
const SALT = "salt"; // must match backend & iOS

const N = 16384, r = 8, p = 1, dkLen = 32;
 
// -------- Key Derivation (scrypt) --------

async function deriveKey(secret) {

  const key = await scrypt(

    new TextEncoder().encode(secret),

    new TextEncoder().encode(SALT),

    N, r, p, dkLen

  );

  return CryptoJS.lib.WordArray.create(key); // CryptoJS compatible WordArray

}
 let cachedKey = null;

async function getKey(secret) {
  if (!cachedKey) {
    const key = await scrypt(
      new TextEncoder().encode(secret),
      new TextEncoder().encode(SALT),
      N, r, p, dkLen
    );
    cachedKey = CryptoJS.lib.WordArray.create(key);
  }
  return cachedKey;
}
// -------- Encrypt (same as iOS) --------

export async function encryptRequestData(parameters, keyString) {

  // const key = await deriveKey(keyString);
  const key = await getKey(keyString);
 
  const iv = CryptoJS.lib.WordArray.random(16); // random IV

  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(parameters), key, {

    iv,

    mode: CryptoJS.mode.CBC,

    padding: CryptoJS.pad.Pkcs7,

  });
 
  const ivHex = iv.toString(CryptoJS.enc.Hex);

  const cipherHex = encrypted.ciphertext.toString(CryptoJS.enc.Hex);
 
  return { payload: `${ivHex}:${cipherHex}` };

}
 
// -------- Decrypt (same as iOS) --------

export async function decryptResponse(encryptedString, keyString) {
  // console.log("object",)

  // clean wrapping quotes, url decoding etc

  const cleaned = encryptedString

     .trim()

    .replace(/^"|"$/g, "")

    .replace(/\\n/g, "")

     .trim();

  const parts = cleaned.split(":");

  if (parts.length !== 2) {

    throw new Error("Invalid encrypted format (expected iv:cipher)");

  }
 
  const iv = CryptoJS.enc.Hex.parse(parts[0]);

  const cipherHex = CryptoJS.enc.Hex.parse(parts[1]);

  const cipherBase64 = CryptoJS.enc.Base64.stringify(cipherHex);
 
  // const key = await deriveKey(keyString);
  const key = await getKey(keyString);
 
  const decrypted = CryptoJS.AES.decrypt(cipherBase64, key, {

    iv,

    mode: CryptoJS.mode.CBC,

    padding: CryptoJS.pad.Pkcs7,

  });
 
  return decrypted.toString(CryptoJS.enc.Utf8);

}

 